module.exports = __webpack_public_path__ + "img/hexaTees.9a53f1d1.svg";